module.exports = "/images/vendor/desiigner-svg/svg/social/instagram.svg?150e29a8169fc6d9311693bce467163d";